module.exports = __webpack_public_path__ + "media/logos/am-trust-logo-092b77b6.png";